import { Category } from '@firmable/contracts';
import { create } from 'zustand';
// Add these to your Search store
export interface SearchState {
  // ... existing state
  scrollPosition: Record<Category, number>;
}

export interface SearchActions {
  // ... existing actions
  setScrollPosition: (category: Category, position: number) => void;
}

export const useSearch = create<SearchState & SearchActions>((set) => ({
  // ... existing state
  scrollPosition: {
    company: 0,
    people: 0,
  },

  // ... existing actions
  setScrollPosition: (category, position) =>
    set((state) => ({
      scrollPosition: {
        ...state.scrollPosition,
        [category]: position,
      },
    })),
}));
